import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNewspaper2"><Path d="M11 8C11 5.79086 9.20914 4 7 4H1V20H9C10.1046 20 11 20.8954 11 22V8Z" fill="currentColor"/><Path d="M13 22C13 20.8954 13.8954 20 15 20H23V4H17C14.7909 4 13 5.79086 13 8V22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper2;
